import {metadaApi} from '@dms/api/base';

import {GetAuthorizationsApiArg, GetAuthorizationsApiResponse} from './types';

const metadaAdminAuthorizationsApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Fetches authorizations from admin service
     * @param queryArg - Query arguments including tenant, workspace, and filter params
     * @returns List of authorizations
     */
    getAuthorizations: build.query<GetAuthorizationsApiResponse, GetAuthorizationsApiArg>({
      query: (queryArg) => ({
        url: `/admin/v1/authorizations`,
        headers: {'x-tenant': queryArg['x-tenant']},
        params: queryArg.params,
      }),
      providesTags: ['authorizationOperations'],
    }),
  }),
});
export const {useGetAuthorizationsQuery} = metadaAdminAuthorizationsApi;
